import type { JanusCtx } from './context.js';
import { hasSurfaceTypeValue } from '../../shared/surface-geometry.js';

/** Source-frame bookkeeping for the existing entry/End Turn log budget. Never infer a historical cast's clock on a receiving peer. */
export function surfaceEntryLogTime(ctx: Pick<JanusCtx, 'rows' | 'read'>): { surface_entry_time?: number[] } {
  if (typeof ctx.read?.definition !== 'function' || typeof ctx.read.value !== 'function' || typeof ctx.read.campaignClock !== 'function') return {};
  if (!ctx.rows.some(row => {
    const definition = row.roll_item_id ? ctx.read.definition(row.roll_item_id) : null;
    return !!definition && hasSurfaceTypeValue(ctx.read.value(definition, 'surface_type'));
  })) return {};
  const clock = ctx.read.campaignClock();
  if (!clock) return {};
  const time = (['year', 'month', 'day', 'hour', 'minute', 'second'] as const).map(unit => clock[unit]);
  return time.every(part => Number.isSafeInteger(part) && part >= 0) ? { surface_entry_time: time } : {};
}
